class Anchor {
  constructor(config = {}) {
    const { anchors } = config;

    this.scrollTo();


    window.addEventListener('hashchange', () => this.scrollTo());
  }

  scrollTo() {
    if (window.location.hash === '') {
      return false;
    }

    const el = document.querySelector(window.location.hash);
    const header = document.querySelector('header');

    if (el !== null) {
      const headerHeight = header ? header.offsetHeight : 0;

      const elementPosition = el.getBoundingClientRect().top + window.pageYOffset;
      const offsetPosition = elementPosition - headerHeight;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth',
      });
    }
  }
}

export default Anchor;
